import {
  queryMemberLevelPage,
  saveMemberLevel,
  updateMemberLevel,
  queryMemberLevelDetail,
  queryMealOrderPage,
  updateMemberLevelStation
} from '@/api/sys.memberLevel'

export default {
  namespaced: true,
  actions: {
    /**
     * 分页查询 时间套餐列表
     */
    queryMemberLevelPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryMemberLevelPage(data)
        .then(res => {
          return res.data.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * @description 新建时间套餐
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param data {Object} 数据
     */
    saveMemberLevel ({
      dispatch
    }, {
      vm,
      data
    }) {
      return saveMemberLevel(data)
        .then(res => {
          return res.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     *
     * 修改时间套餐
     * @param {*} param1
     */
    updateMemberLevel ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求修改时间套餐接口
      return updateMemberLevel(data)
        .then(res => {
          return res.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 查询时间套餐详情
     * @param {*} param0
     * @param {*} param1
     */
    queryMemberLevelDetail ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求所有菜单接口
      return queryMemberLevelDetail(data)
        .then(res => {
          return res.data.data
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
     * 分页查询 时间套餐核销记录列表
     */
    queryMealOrderPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryMealOrderPage(data)
        .then(res => {
          return res.data.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateMemberLevelStation ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求修改时间套餐接口
      return updateMemberLevelStation(data)
        .then(res => {
          return res.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }

}
